<template>
  <footer class="footer" :class="{ 'fullscreen-section': isMobile }" :style="isMobile ? {} : { minHeight: footerHeight + 'px' }">
    <!-- 设计稿内容层：固定1920px，按宽度等比缩放，所有电脑同比例显示 -->
    <div class="footer-inner" :style="{ transform: footerTransform }">
    <div class="footer-nav">
      <div class="footer-nav-item">
        <div class="logo-wrap">
          <img src="../assets/images/product/logo@2x.png" alt="logo" class="footer-logo" />
          <h4 v-if="$i18n.locale !== 'en'">{{ $t('footer.company') }}</h4>
        </div>
        <!-- 底部左侧联系方式：售后服务/商务联系，文案复用 about 页 i18n 键 -->
        <div class="footer-contact">
          <div class="footer-contact-block">
            <h4>{{ $t('about.afterSalesTitle') }}</h4>
            <p>{{ $t('about.afterSalesEmail') }}{{ $t('about.afterSalesEmailValue') }}</p>
            <p>{{ $t('about.afterSalesPhone') }}{{ $t('about.afterSalesPhoneValue') }}</p>
          </div>
          <div class="footer-contact-block">
            <h4>{{ $t('about.businessTitle') }}</h4>
            <p>{{ $t('about.businessEmail') }}{{ $t('about.businessEmailValue') }}</p>
            <p>{{ $t('about.businessPhone') }}{{ $t('about.businessPhoneValue') }}</p>
          </div>
        </div>
      </div>
      <div class="footer-nav-item">
        <h4>{{ $t('footer.home') }}</h4>
        <div class="sub-menu">
          <!-- 可孚孚探：点击跳转首页模块一（已在首页时平滑回顶部，见 goHomeTop） -->
          <a href="#" @click.prevent="goHomeTop">{{ $t('footer.homeSub') }}</a>
        </div>
      </div>
      <div class="footer-nav-item">
        <h4>{{ $t('footer.product') }}</h4>
        <div class="sub-menu">
          <!-- 持续葡萄糖监测系统：跳产品页模块一；线上商城：跳最后模块（官方商城）；英文版隐藏线上商城链接（v-if 移出 DOM，点击一并失效） -->
          <a href="#" @click.prevent="goProduct()">{{ $t('footer.productSub1') }}</a>
          <a v-if="$i18n.locale !== 'en'" href="#" @click.prevent="goProduct('shop')">{{ $t('footer.productSub2') }}</a>
        </div>
      </div>
      <div class="footer-nav-item">
        <h4>{{ $t('footer.service') }}</h4>
        <div class="sub-menu">
          <!-- 客户服务：跳服务页模块一；用户手册：跳模块三（产品使用教程）；常见问题：跳模块二，见 goService -->
          <a href="#" @click.prevent="goService('hero')">{{ $t('footer.serviceSub1') }}</a>
          <a href="#" @click.prevent="goService('video')">{{ $t('footer.serviceSub2') }}</a>
          <a href="#" @click.prevent="goService('faq')">{{ $t('footer.serviceSub3') }}</a>
        </div>
      </div>
      <div class="footer-nav-item">
        <h4>{{ $t('footer.download') }}</h4>
        <div class="sub-menu">
          <!-- 三个链接均跳下载中心页模块一（页面顶部），已在下载页时平滑回顶部，见 goDownload -->
          <a href="#" @click.prevent="goDownload">{{ $t('footer.downloadSub1') }}</a>
          <a href="#" @click.prevent="goDownload">{{ $t('footer.downloadSub2') }}</a>
          <a href="#" @click.prevent="goDownload">{{ $t('footer.downloadSub3') }}</a>
        </div>
      </div>
      <div class="footer-nav-item">
        <h4>{{ $t('footer.about') }}</h4>
        <div class="sub-menu">
          <!-- 公司简介：跳关于页模块二；发展历程：跳模块三；商务联系：跳最后模块（模块四），见 goAbout -->
          <a href="#" @click.prevent="goAbout('intro')">{{ $t('footer.aboutSub1') }}</a>
          <a href="#" @click.prevent="goAbout('feature')">{{ $t('about.devTitle') }}</a>
          <a href="#" @click.prevent="goAbout('contact')">{{ $t('footer.aboutSub2') }}</a>
        </div>
      </div>
    </div>
    <div class="copyright">
      <!-- 隐私政策链接随语言切换：英文站→int（en-US），中文站→api（zh-CN），地址定义在 i18n footer.privacyUrl -->
      {{ $t('footer.copyright') }}-<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{ $t('footer.icp') }}</a> <a :href="$t('footer.privacyUrl')" target="_blank">{{ $t('footer.privacy') }}</a>
    </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      // 页脚缩放比例
      footerScale: 1,
      baseZoom: 1,
      isMobile: window.innerWidth <= 1024
    }
  },
  computed: {
    footerTransform() {
      // 居中 + 缩放：translate(-50%, -50%) 配合 top:50%/left:50% 实现画布居中，scale 等比缩放
      return 'translate(-50%, -50%) scale(' + this.footerScale + ')'
    },
    footerHeight() {
      // 页脚高度跟随缩放比例，避免小屏幕上固定 310px 产生空白
      return Math.ceil(310 * this.footerScale)
    }
  },
  methods: {
    updateFooterScale() {
      // 仅按宽度等比缩放（不用 Math.max 取高度比），避免不同窗口比例下文字/背景缩放不一致
      const fit = window.innerWidth / 1920
      // DPR 补偿：浏览器 Ctrl+/- 缩放时 devicePixelRatio 同步变化，补偿后内容跟随浏览器缩放同步变化
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.footerScale = fit * zoom
      this.isMobile = window.innerWidth <= 1024
    },
    // 点击"可孚孚探"跳转首页模块一：非首页时跳路由（scrollBehavior 会自动落顶），已在首页时平滑滚回顶部
    goHomeTop() {
      if (this.$route.path === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      this.$router.push('/')
    },
    // 点击产品页链接：不传 anchor 跳模块一（页面顶部），传 'shop' 跳最后模块（官方商城）；
    // 已在产品页时直接滚动，否则带 ?to= 参数跳路由，由 Product.vue 接收后滚到对应模块
    goProduct(anchor) {
      if (this.$route.path === '/product') {
        if (anchor) {
          const el = document.querySelector('.module-' + anchor)
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' })
          }
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
        return
      }
      this.$router.push(anchor ? '/product?to=' + anchor : '/product')
    },
    // 点击服务页链接：anchor 对应模块类名（hero 模块一 / faq 模块二 / video 模块三）；
    // 已在服务页时直接滚动，否则带 ?to= 参数跳路由，由 Service.vue 接收后滚到对应模块
    goService(anchor) {
      if (this.$route.path === '/service') {
        const el = document.querySelector('.module-' + anchor)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
        return
      }
      this.$router.push('/service?to=' + anchor)
    },
    // 点击下载中心链接：均跳转下载中心页模块一（页面顶部）；
    // 已在下载页时平滑回顶部，否则跳路由（scrollBehavior 会自动落顶）
    goDownload() {
      if (this.$route.path === '/download') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      this.$router.push('/download')
    },
    // 点击关于页链接：anchor 对应模块类名（intro 模块二 / feature 模块三 / contact 模块四）；
    // 已在关于页时直接滚动，否则带 ?to= 参数跳路由，由 About.vue 接收后滚到对应模块
    goAbout(anchor) {
      if (this.$route.path === '/about') {
        const el = document.querySelector('.module-' + anchor)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
        return
      }
      this.$router.push('/about?to=' + anchor)
    }
  },
  mounted() {
    // 记录初始 DPR 作为基准，用于浏览器缩放补偿
    this.baseZoom = window.devicePixelRatio || 1
    this.updateFooterScale()
    window.addEventListener('resize', this.updateFooterScale)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateFooterScale)
  }
}
</script>

<style scoped>
/* 页脚根容器：青色背景，overflow:hidden 兜底防边缘露白；min-height 由 JS 动态设置跟随缩放 */
.footer {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #00ADBB;
}

/* 页脚内容层：绝对定位居中 + scale 动态缩放，固定 1920px 设计稿宽度；
   双层背景色兜底：外层 .footer 防缩放边缘露白，内层 .footer-inner 承载内容 */
.footer-inner {
  position: absolute;
  top: 47%;
  left: 50%;
  width: 1920px;
  height: auto;
  min-height: 310px;
  padding: 30px 0 30px 0;
  overflow: visible;
  transform-origin: center center;
  background: #00ADBB;
}

/* 导航栏容器：flex 横向排列各列，gap 控制列间距 */
.footer-nav {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 160px;          /* 中文列间距，改这个值调列间距 */
  margin: 0 auto;
  padding: 10px 60px 0 160px;
}

/* 仅桌面端：英文收窄列间距防止总宽超出 */
@media (min-width: 1025px) {
  :lang(en) .footer-nav {
    gap: 140px;
  }
}

/* 水平分隔线：::before 伪元素，用 left+right 控制线长，改 top 调上下位置 */
.footer-nav::before {
  content: '';
  position: absolute;
  top: 60px;       /* logo 下方（logo 40px + gap 16px ≈ 56px，取整 60px） */
  left: 88px;      /* 距 nav 左边缘，1920-88-88=1744px */
  right: 88px;     /* 距 nav 右边缘，改 left/right 调线长 */
  height: 1px;
  background: #FFFFFF;
}

/* 导航列通用样式 */
.footer-nav-item {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

/* logo 与公司名称横排容器 */
.logo-wrap {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 28px;
}

/* logo 图片高度 */
.footer-logo {
  height: 40px;
  display: block;
}

/* 列标题通用样式 */
.footer-nav-item h4 {
  height: 28px;
  font-family: 'PingFang SC', 'PingFang SC';
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin: 0 0 60px 0;
}

/* 仅桌面端：第 2~6 列标题居中 */
@media (min-width: 1025px) {
  .footer-nav-item:not(:first-child) h4 {
    text-align: center;
  }

  /* 仅桌面端：第 2~6 列链接居中 */
  .footer-nav-item:not(:first-child) .sub-menu a,
  .footer-nav-item:not(:first-child) .sub-menu span {
    text-align: center;
  }
}

/* 第一列标题（logo 旁的公司名）无下间距 */
.footer-nav-item:first-child h4 {
  margin: 0;
}

/* 联系方式包裹层：回归文档流，自然排在分隔线下方 */
.footer-contact {
  position: static;
  margin-top: 36px;   /* 改这个值调与分隔线的间距（分隔线 top 60px + 额外 20px） */
}

/* 两组联系方式间距 */
.footer-contact-block + .footer-contact-block {
  margin-top: 16px;
}

/* 联系方式标题 */
.footer-nav-item .footer-contact-block h4 {
  height: auto;
  margin: 0 0 6px 0;
}

/* 联系方式邮箱/电话行 */
.footer-contact-block p {
  font-family: 'PingFang SC', 'PingFang SC';
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  margin: 0 0 0 0;
  white-space: nowrap;
}

/* 子菜单容器 */
.sub-menu {
  margin-top: 0;
}

/* 子菜单链接通用样式 */
.sub-menu a,
.sub-menu span {
  display: block;
  font-family: 'PingFang SC', 'PingFang SC';
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 24px;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 悬停态 */
.sub-menu a:hover {
  color: #fff;
}

/* 版权信息栏：绝对定位居中 */
.copyright {
  position: absolute;
  z-index: 1;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
  font-family: 'PingFang SC', 'PingFang SC';
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  font-style: normal;
  text-transform: none;
}

.copyright a {
  color: #FFFFFF;
  text-decoration: none;
}

.copyright a:hover {
  text-decoration: underline;
}






/* ===== 移动端适配（<= 1024px）：禁用缩放，导航两列网格 ===== */
@media (max-width: 1024px) {
  /* 外层容器：占满一屏 + 纵向居中，保证各页 logo/文字位置一致 */
  .footer {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  /* 内容层脱离绝对定位，改正常文档流；!important 覆盖行内 transform */
  .footer-inner {
    position: static;
    width: 100%;
    height: auto;
    min-height: 0;
    padding: 10vh 3vw 8vh;
    transform: none !important;
  }

  /* 英文版顶部间距单独调节 */
  :lang(en) .footer-inner {
    padding-top: 10vh !important;
  }

  /* 隐藏桌面端分隔线 */
  .footer-inner::before {
    display: none;
  }

  /* 导航栏：改两列网格布局 */
  .footer-nav {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 2.13vw;
    row-gap: 3.6vh;
    max-width: none;
    padding: 0;
    transform: none;
  }

  /* 移动端隐藏桌面端的分隔线 */
  .footer-nav::before {
    display: none;
  }

  /* 第一列（logo+联系方式）占满整行 */
  .footer-nav-item:first-child {
    grid-column: 1 / -1;
    margin: 0;
    transform: none;
  }

  /* 所有列取消间距和偏移 */
  .footer-nav-item,
  :lang(en) .footer-nav-item {
    margin: 0;
    transform: none;
  }

  .footer-nav-item:last-child,
  :lang(en) .footer-nav-item:last-child {
    margin-bottom: 0;
  }

  /* 列标题字号 */
  .footer-nav-item h4 {
    height: auto;
    margin: 0 0 1.33vh 0;
    font-size: 4.8vw;
  }

  /* 联系方式：改文档流 + 横向排列 */
  .footer-contact {
    position: static;
    transform: none;
    margin: 1.6vh 0;
    display: flex;
    gap: 2.67vw;
  }

  .footer-contact-block {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  /* 第一组联系方式微调下移 */
  .footer-contact-block:first-child {
    transform: translateY(2.3vh);
  }

  /* 联系方式文字字号 */
  .footer-contact-block p {
    font-size: 3.2vw;
    margin-bottom: 0.8vh;
  }

  /* 子菜单链接：允许换行 + 字号 */
  .sub-menu a,
  .sub-menu span {
    white-space: normal;
    margin-bottom: 1.07vh;
    font-size: 3.73vw;
  }

  /* 版权信息字号 + 位置 */
  .copyright {
    font-size: 3.2vw;
    bottom: 2.13vh;
    padding: 0 4vw 0 4vw;
  }
}
</style>
